export const metricVariants = {
  default: {
    code: 'default',
    displayName: 'Default',
    description: 'Standard metric layout with optional icon, title, value, and footer.',
    parameters: [
      { key: 'hideIcon', type: 'boolean', label: 'Hide Icon', default: false }
    ],
    resolve: (params) => ({
      props: { hideIcon: params.hideIcon },
      className: null,
      tableClassName: null,
      styles: {}
    })
  },
  card: {
    code: 'card',
    displayName: 'Card',
    description: 'Metric displayed inside a bordered card with subtle shadow. Good for dashboards with multiple KPIs.',
    parameters: [
      { key: 'hideIcon', type: 'boolean', label: 'Hide Icon', default: false }
    ],
    resolve: (params) => ({
      props: { hideIcon: params.hideIcon },
      className: null,
      tableClassName: null,
      styles: {}
    })
  },
  minimal: {
    code: 'minimal',
    displayName: 'Minimal',
    description: 'Compact metric with tight padding and no icon area. Suited for dense information displays.',
    parameters: [
      { key: 'hideIcon', type: 'boolean', label: 'Hide Icon', default: true }
    ],
    resolve: (params) => ({
      props: { hideIcon: params.hideIcon },
      className: null,
      tableClassName: null,
      styles: {}
    })
  }
}
